import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import RoleForm from "./RoleForm";
import { useEffect, useState } from "react";
import { roleValidationForm } from "../../utils/validationSchemas";

const CreateRole = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(roleValidationForm),
  });
  const { handleCreate, isLoading, Permissions } = props;
  const [selectedPermission, setSelectedPermission] = useState([]);

  useEffect(() => {
    setValue("custom_permissions", selectedPermission);
  }, [selectedPermission]);

  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <RoleForm
        selectedUserPermissions={selectedPermission}
        errors={errors}
        register={register}
        setSelectedPermission={setSelectedPermission}
        Permissions={Permissions}
      />
    </FormLayout>
  );
};

export default CreateRole;
